/** Skeleton placeholder primitive. */
import * as React from 'react';
import { cn } from '@/lib/utils';

/** Animated placeholder block. */
function Skeleton({ className, ...props }: Readonly<React.HTMLAttributes<HTMLDivElement>>) {
  return <div className={cn('animate-pulse rounded-md bg-black/10', className)} {...props} />;
}

export { Skeleton };
